import React from 'react';
import cn from 'classnames';
import StickySyncedScrollLayout from '../../../../shared/ui/StickySyncedScrollLayout';
import Header from '../components/Header';
import Body from '../components/Body';
import Pagination from '../components/Pagination';
import BodyCell from '../components/BodyCell';
import CellWithDefault from '../components/CellWithDefault';
import Filter from '../components/Filter';
import Provider from './provider';
import { tableId } from '../constants';
import styles from './index.module.scss';
import PagesSize from '../components/PagesSize';

const Table = ({
  data,
  grouped,
  groupFn,
  withCheckbox = false,
  columns,
  rowKey = 'id',
  renderExpanded,
  filterConfig,
  rowSelectionConfig,
  rowExpansionConfig,
  pageSizeConfig,
  pageConfig,
}) => {
  const { getFilteredData, ..._filterConfig } = filterConfig ?? {};

  return (
    <Provider
      pageConfig={pageConfig}
      filterConfig={_filterConfig}
      rowSelectionConfig={rowSelectionConfig}
      rowExpansionConfig={rowExpansionConfig}
      pageSizeConfig={pageSizeConfig}
      data={data}
      getFilteredData={getFilteredData}
      rowKey={rowKey}
      columns={columns}
      withCheckbox={withCheckbox}
      shouldMeasure={grouped}
    >
      <StickySyncedScrollLayout
        className={cn(styles.root, {
          [styles.hasCheckbox]: withCheckbox,
        })}
        rootId={tableId}
        header={
          <Header
            columns={columns}
            withCheckbox={withCheckbox}
            rowKey={rowKey}
          />
        }
      >
        <Body
          grouped={grouped}
          columns={columns}
          withCheckbox={withCheckbox}
          rowKey={rowKey}
          groupFn={groupFn}
          renderExpanded={renderExpanded}
          hasData={data?.length > 0}
        />
      </StickySyncedScrollLayout>
      <div className={styles.footer}>
        <PagesSize />
        <Pagination />
      </div>
    </Provider>
  );
};

Table.BodyCell = BodyCell;
Table.BodyCellWithDefault = CellWithDefault;
Table.Filter = Filter;

export default Table;
